// ホーム ヒーロー
function homeHero () {
	var el = document.querySelector('.home-hero');

	if (!el) {
		return;
	}

	var photos = el.querySelectorAll('.home-hero__photos__item');
	var duration = 1000;
	var interval = 6000;
	var media = window.matchMedia('(min-width: 768px)');
	var currentIndex = -1;

	var raf = window.requestAnimationFrame || function(callback) {
		seetTimeout(callback, 16);
	};

	var loadImg = function (index, callback) {
		callback = callback || function(){};

		if (photos[index].hasAttribute('data-loaded')) {
			return callback();
		}
		photos[index].setAttribute('data-loaded', 1);

		var src = photos[index].getAttribute(media.matches ? 'data-lg' : 'data-sm');
		var img = document.createElement('img')
		img.onload = function () {
			photos[index].style.backgroundImage = 'url(' + src + ')';
			callback()
		};
		img.src = src;
	};

	var next = function () {
		raf(function(){
			var index = (currentIndex + 1) % photos.length;

			if (currentIndex >= 0) {
				photos[currentIndex].style.WebkitTransitionDelay = duration + 'ms';
				photos[currentIndex].style.transitionDelay = duration + 'ms';
				photos[currentIndex].classList.remove('is--active');
			}

			photos[index].style.WebkitTransitionDuration = duration + 'ms';
			photos[index].style.transitionDuration = duration + 'ms';
			photos[index].classList.add('is--active');
			currentIndex = index;

			if (photos.length < 2) {
				return;
			}

			loadImg((currentIndex + 1) % photos.length);
			raf(function(){
				setTimeout(next, duration + interval);
			});
		});
	};

	loadImg(0, next);
}

module.exports = homeHero;